import { Box, Button, Card, CardContent, Stack, Typography } from '@mui/material'
import BusinessRounded from '@mui/icons-material/BusinessRounded'
import AdminPanelSettingsRounded from '@mui/icons-material/AdminPanelSettingsRounded'
import { useAuth } from '../auth/AuthProvider'
import { clientConsoleUrl, managementConsoleUrl } from '../lib/console'
import { BrandBackground } from '../components/BrandBackground'
import { PublicHeader } from '../components/PublicHeader'
import { AppFooter } from '../components/AppFooter'

// Barreira de console: cada domínio serve o mesmo SPA, mas cada papel só tem lugar em um
// deles. Admin de plataforma (não-super) só no console de gestão; cliente/agência só no
// console do cliente. SUPER_ADMIN não passa por aqui (abre os dois). Em localhost também
// não -- ver ProtectedRoute / lib/console.
export function WrongConsolePage({ target }: { target: 'management' | 'client' }) {
  const auth = useAuth()
  const toManagement = target === 'management'
  const url = toManagement ? managementConsoleUrl() : clientConsoleUrl()

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', position: 'relative' }}>
      <BrandBackground />
      <PublicHeader action={<Button size="small" onClick={() => auth.logout()}>Sair</Button>} />
      <Box sx={{ flex: 1, display: 'grid', placeItems: 'center', p: 2 }}>
        <Card sx={{ width: '100%', maxWidth: 460, boxShadow: '0 28px 64px -24px rgba(15,23,42,.28), 0 0 0 1px rgba(15,23,42,.04)' }}>
          <CardContent sx={{ p: { xs: 3, sm: 5 } }}>
            <Stack alignItems="center" textAlign="center" gap={2}>
              <Stack sx={{ width: 88, height: 88, borderRadius: 4, display: 'grid', placeItems: 'center', color: 'white', background: 'linear-gradient(135deg,#2563eb,#0ea5e9)', boxShadow: '0 16px 34px -14px rgba(37,99,235,.55)' }}>
                {toManagement ? <AdminPanelSettingsRounded sx={{ fontSize: 40 }} /> : <BusinessRounded sx={{ fontSize: 40 }} />}
              </Stack>
              <Typography variant="h5">Console errado para a sua conta</Typography>
              <Typography color="text.secondary">
                {toManagement
                  ? 'Sua conta é de administrador da plataforma. A gestão fica no console administrativo.'
                  : 'Este é o console de gestão da plataforma. Sua conta é de cliente ou agência — use o painel do cliente.'}
              </Typography>
              <Button href={url} fullWidth size="large" variant="contained" sx={{ bgcolor: '#2563eb', '&:hover': { bgcolor: '#1d4ed8' } }}>
                {toManagement ? 'Ir para o console administrativo' : 'Ir para o painel do cliente'}
              </Button>
            </Stack>
          </CardContent>
        </Card>
      </Box>
      <AppFooter />
    </Box>
  )
}
